

function StepperComponent(props) {

  React.useEffect(() => {

    console.log("StepperComponent props", props)
    ProgressBar.singleStepAnimation = 1500;
    ProgressBar.init(
      props.steps,
      props.current, // current stage
      'order-status-stepper' // created this optional parameter for container name (otherwise default container created)
    );
  }, [props.steps, props.current])

  return (
    <div id="orderstepper" className="order-status-stepper orderstepper">

    </div>
  )
}

export function DeliveryStepperComponent(props) {

  let steps = ['¡Pedido Pendiente!', 'Confirmado!', 'Listo!', 'Enviado!']
  let current = '¡Pedido Pendiente!'

  switch (props.status) {
    case 'confirmed':
    case 'preparing':
    case 'deliveryaccepted':
      current = 'Confirmado!'
      break;
    case 'ready':
      current = 'Listo!'
      break;
    case 'dispatched':
      current = 'Enviado!'
      break;
    case 'delivered':
      steps[3] = 'Entregado!'
      current = 'Entregado!'
      break;
  }

  return <StepperComponent steps={steps}  current={current} />
}

export function TakeawayStepperComponent(props) {

  let steps = ['¡Pedido Pendiente!', 'Confirmado!', 'Listo!', 'Recogido!']
  let current = '¡Pedido Pendiente!'

  switch (props.status) {
    case 'confirmed':
    case 'preparing':
    case 'deliveryaccepted':
      current = 'Confirmado!'
      break;
    case 'ready':
      current = 'Listo!'
      break;
    case 'dispatched':
    case 'delivered':
      current = 'Recogido!'
      break;
  }

  return <StepperComponent steps={steps}  current={current} />
}

export function PaymentStepperComponent(props) {

  let steps = ['¡Pedido Pendiente!', 'Confirmado!', 'Listo!', 'Entregado!']
  let current = '¡Pedido Pendiente!'

  if (props.status === 'paymentrequired' ||props.status === 'paid') {
    steps = ['¡Pedido Pendiente!','Pago Requerido!','Pagado!', 'Confirmado!']
    current = '¡Pedido Pendiente!'
  }

  switch (props.status) {
    case 'paymentrequired':
      current = '¡Pedido Requerido!'
      break;
    case 'paid':
      current = '¡Pagado!'
      break;
    case 'confirmed':
    case 'preparing':
      current = 'Confirmado!'
      break;
    case 'ready':
       current = 'Listo!'
      break;
    case 'sent':
    case 'delivered':
    case 'dispatched':
      current = 'Entregado!'
      break;
  }

  return <StepperComponent steps={steps}  current={current} />
}

export function RejectedStepperComponent(props) {
  return <StepperComponent steps={['¡Pedido Pendiente!', '¡Pedido Rechazado!']}
    current={'¡Pedido Rechazado!'} />
}
/*
export function ChangedStepperComponent(props) {
  return <div>ChangedStepperComponent</div>
}

export function CostsStepperComponent(props) {
  return <div>CostsStepperComponent</div>
} */